import { render, staticRenderFns } from "./RegisterModalContent.vue?vue&type=template&id=0cd3d389&scoped=true&"
var script = {}
import style0 from "./RegisterModalContent.vue?vue&type=style&index=0&id=0cd3d389&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd3d389",
  null
  
)

export default component.exports